// returns updated list of patient visits when adding new row data.
import { SmartChartIPU } from '@mummssoftware/utils/constants';
import { getVisitByPersonAndVisitId } from '@mummssoftware/utils/pimReader';

const sumDetails = details => (details === null || details === void 0 ? void 0 : details.manifestcount) + (details === null || details === void 0 ? void 0 : details.notecount) + (details === null || details === void 0 ? void 0 : details.measurecount) + (details === null || details === void 0 ? void 0 : details.taskadmincount) + (details === null || details === void 0 ? void 0 : details.taskadminrefusedcount) + (details === null || details === void 0 ? void 0 : details.problemcount);

export const fetchDetails = async (appVisit, keycloak, personNumber, agency) => {
  const response = await getVisitByPersonAndVisitId(personNumber, appVisit === null || appVisit === void 0 ? void 0 : appVisit.id.toString(), agency, keycloak); // if the api call wasnt a success, they should not be able to
  // delete the visit.

  if (!response || response instanceof Response) {
    return null;
  }

  return response[0];
};
export const isVisitOKToDelete = async (appVisit, keycloak, personNumber, agency) => {
  const hasDetails = !!appVisit.notecount;

  if (appVisit !== null && appVisit !== void 0 && appVisit.id) {
    const details = hasDetails ? appVisit : await fetchDetails(appVisit, keycloak, personNumber, agency);
    const sum = details && sumDetails(details);
    return sum === 0 && appVisit.sourceofchange !== SmartChartIPU;
  }

  return false;
};